import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bidi-achievements',
  templateUrl: './achievements.component.html',
  styleUrls: ['./achievements.component.scss']
})
export class AchievementsComponent implements OnInit {
  @Output() panelState: EventEmitter<any> = new EventEmitter;
  state = false;
  constructor() { }

  ngOnInit() {
  }

  closeAchievements() {
    this.panelState.emit({state: this.state, panel: 'Logros'});
  }
}
